import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Heading, Text } from '../Elements';

import classes from './RadioButton.module.scss';

const RadioButton = ({
  handleUnit,
  unit,
  units,
  unitsLabel = [],
  name,
  title,
  type = 'l',
  classTitle,
  classLabel,
  className,
  disabled = false
}) => {
  return (
    <>
      {title && (
        <Heading className={cn(classes.heading, classTitle)}>{title}</Heading>
      )}
      <div
        className={cn(
          classes.wrap,
          type === 'l' && classes.wrap_l,
          type === 's' && classes.wrap_s,
          type === 'c' && classes.wrap_c,
          className
        )}
      >
        {units.map((item, ind) => (
          <label
            key={item}
            className={cn(
              classes.label,
              type === 'l' ? classes.label_l : classes.label_s,
              unit === item && type !== 'c' && classes.active
            )}
          >
            {unitsLabel.length > ind ? (
              <Text
                className={cn(
                  type === 's' && classes.text,
                  type === 'c' && classes.text_c,
                  unit === item && type === 'c' && classes.active_c,
                  classLabel
                )}
                aria-label={unitsLabel.length > ind && unitsLabel[ind]}
              >
                {item}
              </Text>
            ) : (
              <Text
                className={cn(
                  type === 's' && classes.text,
                  type === 'c' && classes.text_c,
                  unit === item && type === 'c' && classes.active_c,
                  classLabel
                )}
              >
                {item}
              </Text>
            )}
            <input
              className={classes.visually_hidden}
              type="radio"
              name={name}
              value={item}
              onChange={handleUnit}
              checked={unit === item}
              disabled={disabled}
            />
          </label>
        ))}
      </div>
    </>
  );
};

RadioButton.propTypes = {
  unit: PropTypes.string,
  units: PropTypes.arrayOf(PropTypes.string),
  unitsLabel: PropTypes.arrayOf(PropTypes.string),
  handleUnit: PropTypes.func,
  name: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.oneOf(['l', 's', 'c']),
  classTitle: PropTypes.string,
  classLabel: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string
};

export default RadioButton;
